import { type Asset } from '@/services/db/asset/entity';
import { isEmptyString } from '@/utils/string';

export function getCreatorName(asset: Asset): string {
  const createdBy = asset.created_by;
  if (createdBy == null) return '';
  const firstName = createdBy.first_name?.trim() ?? '';
  const lastName = createdBy.last_name?.trim() ?? '';
  const nameParts = [firstName, lastName].filter((part) => !isEmptyString(part));
  if (nameParts.length > 0) return nameParts.join(' ');
  if (!isEmptyString(createdBy.email)) return createdBy.email;
  return '';
}
